(function () {
  // Run after DOM ready (and after your gallery HTML exists)
  function initMetafieldVideo() {
    var meta = document.getElementById('product-metafield-video');
    if (!meta) return;

    var raw = (meta.getAttribute('data-video-url') || '').trim();
    if (!raw) return;

    // Extract YouTube ID from many URL formats (watch?v=, youtu.be/, /shorts/, embed/)
    var m = raw.match(/(?:v=|\/shorts\/|youtu\.be\/|embed\/)([A-Za-z0-9_\-]{6,})/);
    var videoId = m ? m[1] : raw;

    // Prevent duplicate injection
    if (document.querySelector('[data-youtube="' + videoId + '"]')) return;

    // Build the slide HTML (matches your theme structure)
    var wrapper = document.createElement('div');
    wrapper.className = 'productView-image productView-image-adapt';
    wrapper.innerHTML = '\
  <div class="productView-img-container product-single__media" data-media-id="youtube-' + videoId + '">\
    <div class="media has-video">\
      <img \
        src="https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg" \
        srcset="https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg 1x, https://i.ytimg.com/vi/' + videoId + '/maxresdefault.jpg 2x" \
        alt="Product video" \
        loading="lazy" \
      >\
    </div>\
    <div class="productView-video youtube" data-type="youtube" data-video-url="' + videoId + '">\
      <div data-youtube="' + videoId + '"></div>\
    </div>\
  </div>';

    // Find the gallery container (try common selectors, fallbacks)
    var gallery = document.querySelector('.productView-images') ||
                  document.querySelector('.productView-gallery') ||
                  document.querySelector('.product-gallery') ||
                  document.querySelector('.productView-thumbnails') ||
                  document.querySelector('.productView-nav');

    if (!gallery) {
      // last resort: try to place inside the main gallery wrapper if known
      gallery = document.querySelector('.productView');
    }
    if (!gallery) return;

    // Append slide (you can change to insertBefore for a different position)
    gallery.appendChild(wrapper);

    // Re-init theme's YouTube handler so it picks up the new [data-youtube]
    // Most themes expect jQuery; try both possibilities.
    if (window.halo && typeof window.halo.initYoutubeCarousel === 'function') {
      try {
        // pass a jQuery object if available (many themes expect that)
        var jq = window.jQuery ? window.jQuery(gallery) : gallery;
        window.halo.initYoutubeCarousel(jq);
      } catch (e) {
        // fallback: try a delayed init
        setTimeout(function () {
          if (window.halo && typeof window.halo.initYoutubeCarousel === 'function') {
            var jq2 = window.jQuery ? window.jQuery(gallery) : gallery;
            window.halo.initYoutubeCarousel(jq2);
          }
        }, 300);
      }
    } else {
      // If halo not available yet, poll briefly until it's ready then init
      var tries = 0;
      var poll = setInterval(function () {
        if (window.halo && typeof window.halo.initYoutubeCarousel === 'function') {
          clearInterval(poll);
          try {
            var jq3 = window.jQuery ? window.jQuery(gallery) : gallery;
            window.halo.initYoutubeCarousel(jq3);
          } catch (e) { /* noop */ }
        }
        tries++;
        if (tries > 10) clearInterval(poll);
      }, 300);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMetafieldVideo);
  } else {
    initMetafieldVideo();
  }
})();
